/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function(event){
    var mm = gsap.matchMedia();

    mm.add("(min-width: 1025px)", () => {
        // GSAP industries list animations
        var industriesListContainer = document.querySelector('.wp-block-create-block-mq20-industries-list');
        var industriesListParagraph = document.querySelector('.industries-list-header p');

        function initServicesScrollAnimation() {
            var industriesListScrollAnimationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: industriesListContainer,
                    start: "top +=90%",
                    end: "bottom bottom"
                }
            });

            var headingAnimationProps = {
                y: 20,
                opacity: 0,
                duration: 0.2,
                ease: "power3.inOut"
            };

            industriesListScrollAnimationTimeline
                .from(industriesListParagraph, {...headingAnimationProps, delay: 0.1});

            document.querySelectorAll('.industries-list-item').forEach((item) => {
                var industriesListItemsContainer = item.querySelector(".industries-list-item-case-studies");
                var industriesListItems = gsap.utils.toArray(item.querySelectorAll(".case-study-slide-item"));

                var industriesListScrollItemsAnimationTimeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: industriesListItemsContainer,
                        start: "top +=80%",
                        end: "bottom bottom"
                    },
                });

                var itemsAnimationProps = {
                    y: 20,
                    opacity: 0,
                    duration: 0.2,
                    ease: "power3.inOut",
                    stagger: 0.2
                };

                industriesListScrollItemsAnimationTimeline.from(industriesListItems, itemsAnimationProps);
            });
        }

        initServicesScrollAnimation();
    });

    mm.add("(max-width: 1024px)", () => {
        document.querySelectorAll('.industries-list-item').forEach((carouselContainer) => {
            const loop = horizontalLoop(carouselContainer.querySelectorAll(".case-study-slide-item"), {paused: true});

            carouselContainer.querySelector(".next").addEventListener("click", () => loop.next({duration: 0.3, ease: "none"}));
            carouselContainer.querySelector(".prev").addEventListener("click", () => loop.previous({duration: 0.3, ease: "none"}));

            carouselContainer.querySelectorAll('.case-study-slide-item').forEach((element, index) => {
                element.addEventListener('click', () => {
                    let length = gsap.utils.toArray('.case-study-slide-item').length;
                    let diff = length - loop.current();
                    let distanceToSlide = index + diff;
                    let modifiedIndex = index < loop.current() ? loop.current() + distanceToSlide : index;
                    loop.toIndex(modifiedIndex , {duration: 1 , ease: "none"});
                });
            });

            function horizontalLoop(items, config) {
                items = gsap.utils.toArray(items);
                config = config || {};
                let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}}),
                    length = items.length,
                    startX = items[0].offsetLeft,
                    times = [],
                    widths = [],
                    xPercents = [],
                    curIndex = 0,
                    pixelsPerSecond = (config.speed || 1) * 100,
                    snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1),
                    totalWidth, curX, distanceToStart, distanceToLoop, item, i;

                gsap.set(items, {xPercent: (i, el) => {
                    let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
                    xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
                    return xPercents[i];
                }});
                gsap.set(items, {x: 0});
                totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX")
                for (i = 0; i < length; i++) {
                    item = items[i];
                    curX = xPercents[i] / 100 * widths[i];
                    distanceToStart = item.offsetLeft + curX - startX;
                    distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
                    tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
                    .fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
                    .add("label" + i, distanceToStart / pixelsPerSecond);
                    times[i] = distanceToStart / pixelsPerSecond;
                }
                function toIndex(index, vars) {
                    vars = vars || {};
                    let newIndex = gsap.utils.wrap(0, length, index),
                        time = times[newIndex];
                    if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
                        vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())};
                        time += tl.duration() * (index > curIndex ? 1 : -1);
                    }
                    curIndex = newIndex;

                    const curItem = carouselContainer.querySelector('.industries-list-items-counter .counter-visible');
                    curItem.textContent = curIndex + 1;

                    const progressBarActive = carouselContainer.querySelector('.industries-list-items-counter .counter-progress-active');
                    progressBarActive.style.width = `${(curIndex + 1) / length * 100}%`;

                    const prevButton = carouselContainer.querySelector('.industries-list-buttons .prev');
                    const nextButton = carouselContainer.querySelector('.industries-list-buttons .next');

                    if (curIndex === 0) {
                        prevButton.setAttribute('disabled', 'disabled');
                        prevButton.classList.add('disabled');
                    }
                    else {
                        prevButton.removeAttribute('disabled');
                        prevButton.classList.remove('disabled');
                    }

                    if (curIndex === length - 1) {
                        nextButton.setAttribute('disabled', 'disabled');
                        nextButton.classList.add('disabled');
                    }
                    else {
                        nextButton.removeAttribute('disabled');
                        nextButton.classList.remove('disabled');
                    }

                    vars.overwrite = true;
                    return tl.tweenTo(time, vars);
                }

                tl.next = vars => toIndex(curIndex + 1, vars);
                tl.previous = vars => toIndex(curIndex - 1, vars);
                tl.current = () => curIndex;
                tl.toIndex = (index, vars) => toIndex(index, vars);
                tl.times = times;
                return tl;
            }
        });
    });


    const splitTypes = document.querySelectorAll(".industries-list-header h2");

    splitTypes.forEach((char, i) => {
        const bgColor = "#5E616B";
        const fgColor = "#ffffff";

        const text = new SplitType(char, { types: "words, chars" });

        gsap.fromTo(
            text.chars,
            {
                color: bgColor
            },
            {
                color: fgColor,
                duration: 1,
                stagger: 0.05,
                opacity: 1,
                scrollTrigger: {
                    trigger: char,
                    start: "top 80%",
                    end: "top 30%",
                    scrub: true,
                    toggleActions: "play play reverse reverse",
                }
            }
        );
    });


});
